// This file was automatically generated from appchart.letters.ftue.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.letters.ftue');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.dialog = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEIntroDialogContents"><p class="el8FTUEIntroDialogText">Did you know that you can fax this straight from Elation?</p><div class="el8Spacer5"></div><p class="el8FTUEIntroDialogBigText padb15">Save yourself time and paper.</p><ul><li class="inline"><button class="el8button fax-ftue-trigger el8SpecialGreenButton">Try faxing now</button></li><li class="inline"><button class="el8button print-trigger">Print instead</button></li></ul></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.searchPrompt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEStepCount">Step 1 of 3</p><p class="el8FTUEText">Search your contacts by typing a name, or you can just enter a fax number.</p></div><div class="el8FTUEBoxPointerTopLeft"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.attachmentSection = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEText">Your document is attached here. Attach more from the patient\'s chart by clicking "Attach Chart Items" or clicking "Send to Provider" on the chart feed items.</p></div><div class="el8FTUEBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.editContact = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEStepCount">Step 2 of 3</p><p class="el8FTUEText">If you need to edit this person\'s contact information, click "Edit." <button class="el8button jump-to-end el8FTUEOkButton">Ok</button></p></div><div class="el8FTUEBoxPointerTopRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.addDetails = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEStepCount">Step 2 of 3</p><p class="el8FTUEText">To fax to this person, you will need to add their fax number by clicking "Add Details."<p></div><div class="el8FTUEBoxPointerTopRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.addNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEStepCount">Step 2 of 3</p><p class="el8FTUEText">To fax to this person, you will need to create a contact with a fax number by clicking "Add New."<p></div><div class="el8FTUEBoxPointerTopRight"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.blurField = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEText">Hit "tab" or click outside the field to continue.</p></div><div class="el8FTUEBoxPointerTopLeft"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.letters.ftue.send = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8FTUEStepCount">Step 3 of 3</p><p class="el8FTUEText">When you\'re finished with your letter, click here to send it. <button class="el8button finish-trigger el8FTUEOkButton">Ok</button></p></div><div class="el8FTUEBoxPointerBottom"></div>');
  if (!opt_sb) return output.toString();
};
